export const contradictionSolvingsTypes = {
  TASK_UNIFICATION: "taskUnification",
  ATTRIBUTE_DEPENDENCY: "attributeDependency",
};
